export default __webpack_public_path__ + "static/media/next-arrow.fc268022.svg";